(function(){
  'use strict';

  var VERSION = 'v115';
  var CACHE_KEY = 'labosch_spotlight_cache_v115';
  var CACHE_TTL = 15 * 60 * 1000;
  var MAX_CACHE = 36;
  var boundOverlays = new WeakSet();

  function esc(value){
    return String(value == null ? '' : value)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#039;');
  }

  function numberValue(value){
    if(value === null || value === undefined || value === '') return NaN;
    if(typeof value === 'number') return value;
    var raw = String(value).trim().replace(/\s/g,'');
    if(!raw) return NaN;
    if(raw.indexOf(',') > -1 && raw.indexOf('.') > -1){
      if(raw.lastIndexOf(',') > raw.lastIndexOf('.')) raw = raw.replace(/\./g,'').replace(',','.');
      else raw = raw.replace(/,/g,'');
    }else if(raw.indexOf(',') > -1){
      var parts = raw.split(',');
      raw = parts.length === 2 && parts[1].length <= 2 ? parts[0].replace(/\./g,'') + '.' + parts[1] : raw.replace(/,/g,'');
    }
    raw = raw.replace(/[^0-9.-]/g,'');
    return Number(raw);
  }

  function productImage(product){
    var image = product && (product.featured_image || product.image);
    if(!image) return '';
    if(typeof image === 'string') return image;
    return image.url || image.src || '';
  }

  function thumbUrl(url, width){
    if(!url) return '';
    width = width || 144;
    try{
      var absolute = new URL(url, window.location.origin);
      absolute.searchParams.set('width', String(width));
      return absolute.href;
    }catch(e){
      var joiner = url.indexOf('?') > -1 ? '&' : '?';
      return url + joiner + 'width=' + width;
    }
  }

  function productImageAlt(product){
    var image = product && product.featured_image;
    if(image && typeof image === 'object' && image.alt) return image.alt;
    return product && product.title ? product.title : '';
  }

  function yearFromValue(value){
    if(value === null || value === undefined) return '';
    var text = Array.isArray(value) ? value.join(' ') : String(value);
    var match = text.match(/\b(20(?:2[0-9]))\b/);
    return match ? match[1] : '';
  }

  function productYear(product){
    return yearFromValue(product && product.tags) ||
      yearFromValue(product && product.title) ||
      yearFromValue(product && product.handle) ||
      yearFromValue(product && product.url) || '';
  }

  function productUrl(product){
    return (product && product.url) || (product && product.handle ? '/products/' + product.handle : '#');
  }

  function readSessionCache(){
    try{
      var raw = sessionStorage.getItem(CACHE_KEY);
      if(!raw) return new Map();
      var parsed = JSON.parse(raw);
      if(!parsed || !Array.isArray(parsed.items)) return new Map();
      var now = Date.now();
      return new Map(parsed.items.filter(function(entry){
        return entry && entry[1] && (now - entry[1].time) < CACHE_TTL;
      }).map(function(entry){ return [entry[0], entry[1]]; }));
    }catch(e){ return new Map(); }
  }

  function saveSessionCache(cache){
    try{
      var items = Array.from(cache.entries()).slice(-MAX_CACHE);
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({version:VERSION,items:items}));
    }catch(e){}
  }

  function bootLiveSearch(){
    var overlays = Array.prototype.slice.call(document.querySelectorAll('[data-mg2-search-overlay]'));
    if(!overlays.length) return;

    /* On Shopify/Prestige partial navigations a fresh header can be inserted while
       the previous detached search overlay is still under <body>. Prefer the
       overlay that belongs to the current header and discard stale detached copies. */
    var overlay = overlays.filter(function(item){ return !!item.closest('.mg2-header'); })[0] || overlays[overlays.length - 1];
    overlays.forEach(function(item){
      if(item !== overlay && item.parentNode === document.body && item.dataset.mg2V35Detached === 'true'){
        try{ item.remove(); }catch(e){}
      }
    });

    if(overlay.parentNode !== document.body){
      overlay.dataset.mg2V35Detached = 'true';
      document.body.appendChild(overlay);
    }
    if(boundOverlays.has(overlay)) return;
    boundOverlays.add(overlay);
    overlay.dataset.mg2V35Ready = 'true';

    var form = overlay.querySelector('[data-mg2-live-search-form]');
    var input = overlay.querySelector('[data-mg2-live-search-input]');
    var content = overlay.querySelector('[data-mg2-live-search-content]');
    var results = overlay.querySelector('[data-mg2-search-results]');
    var status = overlay.querySelector('[data-mg2-search-status]');
    var empty = overlay.querySelector('[data-mg2-search-empty]');
    var all = overlay.querySelector('[data-mg2-search-all]');
    if(!form || !input || !content || !results || !status || !empty || !all) return;

    var currency = content.getAttribute('data-currency') || 'EUR';
    var locale = content.getAttribute('data-locale') || document.documentElement.lang || 'es-ES';
    var formatter;
    try{
      formatter = new Intl.NumberFormat(locale,{style:'currency',currency:currency,maximumFractionDigits:0,minimumFractionDigits:0});
    }catch(e){ formatter = null; }

    function money(value){
      var n = numberValue(value);
      if(!Number.isFinite(n)) return '';
      if(n > 100000 && Number.isInteger(n)) n = n / 100;
      if(formatter){ try{return formatter.format(n);}catch(e){} }
      return Math.round(n).toLocaleString('es-ES') + ' €';
    }

    var timer = null;
    var controller = null;
    var requestId = 0;
    var activeIndex = -1;
    var cache = readSessionCache();
    var lastProducts = [];
    var lastQuery = '';
    var lastHoverRow = null;
    var variantIndex = null;
    var variantIndexPromise = null;
    var variantIndexCacheKey = 'labosch_variant_search_index_global_v115';
    var indexBase = content.getAttribute('data-search-index-base') || (((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/') + 'collections/all');
    function indexSources(){
      var rootRoute=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      var rows=[
        indexBase,
        rootRoute+'collections/bicicletas-electricas-ebikes-labosch',
        rootRoute+'collections/bicicletas-electricas-labosch',
        rootRoute+'collections/bicicletas-electricas',
        rootRoute+'collections/comprar-ebikes',
        rootRoute+'collections/e-bikes',
        rootRoute+'collections/all'
      ];
      var seen=Object.create(null);
      return rows.filter(function(url){url=String(url||'').trim();if(!url||seen[url])return false;seen[url]=1;return true;});
    }

    function stripCodePrefix(value){
      return String(value||'').replace(/^\s*(?:sku|ean|ref(?:erencia)?|supplier\s*ref(?:erence)?)\s*[:#\-]?\s*/i,'');
    }
    function normalizeCode(value){
      return stripCodePrefix(value).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]/g,'');
    }
    function carryPreviewParams(u){
      try{
        var current=new URL(window.location.href);
        ['preview_theme_id','_fd','pb'].forEach(function(key){
          if(current.searchParams.has(key)&&!u.searchParams.has(key))u.searchParams.set(key,current.searchParams.get(key));
        });
      }catch(e){}
      return u;
    }
    function indexUrl(page,mode,sourceBase){
      var u=new URL(sourceBase||indexBase,window.location.origin);
      u.searchParams.set('page',String(page||1));
      u.searchParams.set('_','v115');
      if(mode==='section')u.searchParams.set('sections','labosch-search-index');
      else u.searchParams.set('view','labosch-search-index');
      carryPreviewParams(u);
      return u.pathname+u.search;
    }
    function parseIndexPayload(text,mode){
      var raw=String(text||'').trim();
      if(!raw)throw new Error('INDEX_EMPTY');
      if(mode==='section'){
        var wrapper=JSON.parse(raw);
        var html=wrapper&&wrapper['labosch-search-index'];
        if(!html)throw new Error('INDEX_SECTION_EMPTY');
        var holder=document.createElement('textarea');
        holder.innerHTML=html;
        raw=(holder.value||html).trim();
      }
      /* Accept raw JSON and section/template wrappers. */
      if(raw.charAt(0)!=='{'){
        var doc=new DOMParser().parseFromString(raw,'text/html');
        var payloadNode=doc.querySelector('[data-lbx-search-index-payload]');
        if(payloadNode)raw=String(payloadNode.textContent||'').trim();
        else{
          var first=raw.indexOf('{'),last=raw.lastIndexOf('}');
          if(first>=0&&last>first)raw=raw.slice(first,last+1);
        }
      }
      return JSON.parse(raw);
    }
    function fetchIndexPageWithMode(page,collected,mode,sourceBase){
      collected=collected||[];
      return fetch(indexUrl(page,mode,sourceBase),{headers:{'Accept':'application/json,text/html,*/*'},credentials:'same-origin',cache:'no-store'})
        .then(function(response){if(!response.ok)throw new Error('INDEX_HTTP_'+response.status);return response.text();})
        .then(function(text){
          var payload=parseIndexPayload(text,mode);
          var merged=collected.concat((payload&&payload.products)||[]);
          if(payload&&payload.has_next&&payload.next_page&&Number(payload.next_page)<=12)return fetchIndexPageWithMode(Number(payload.next_page),merged,mode,sourceBase);
          return merged;
        });
    }
    function fetchIndexPage(page,collected,sourceBase){
      return fetchIndexPageWithMode(page||1,collected||[],'section',sourceBase).catch(function(){
        return fetchIndexPageWithMode(page||1,collected||[],'view',sourceBase);
      });
    }
    var productsJsonIndex=null;
    var productsJsonPromise=null;
    function fetchProductsJsonPage(page,collected){
      collected=collected||[];
      var rootRoute=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      var url=rootRoute+'products.json?limit=250&page='+encodeURIComponent(page||1)+'&_='+encodeURIComponent('v115');
      return fetch(url,{headers:{'Accept':'application/json'},credentials:'same-origin',cache:'no-store'})
        .then(function(response){if(!response.ok)throw new Error('PRODUCTS_JSON_HTTP_'+response.status);return response.json();})
        .then(function(data){
          var rows=(data&&data.products)||[];
          var mapped=rows.map(function(product){return {
            id:product.id,handle:product.handle,title:product.title,vendor:product.vendor,product_type:product.product_type,url:'/products/'+product.handle,
            image:(product.images&&product.images[0]&&product.images[0].src)||'',price_min:product.variants&&product.variants[0]?product.variants[0].price:null,
            compare_at_price_min:product.variants&&product.variants[0]?product.variants[0].compare_at_price:null,
            variants:(product.variants||[]).map(function(v){return {id:v.id,title:v.title,sku:v.sku||'',supplier_ref:'',barcode:v.barcode||''};})
          };});
          var merged=collected.concat(mapped);
          if(rows.length===250&&Number(page||1)<12)return fetchProductsJsonPage(Number(page||1)+1,merged);
          return merged;
        });
    }
    function getProductsJsonIndex(){
      if(Array.isArray(productsJsonIndex))return Promise.resolve(productsJsonIndex);
      if(productsJsonPromise)return productsJsonPromise;
      productsJsonPromise=fetchProductsJsonPage(1,[]).then(function(items){productsJsonIndex=items||[];return productsJsonIndex;}).finally(function(){productsJsonPromise=null;});
      return productsJsonPromise;
    }
    function getVariantIndex(){
      if(Array.isArray(variantIndex))return Promise.resolve(variantIndex);
      if(variantIndexPromise)return variantIndexPromise;
      try{
        var cachedRaw=sessionStorage.getItem(variantIndexCacheKey);
        if(cachedRaw){
          var cachedObj=JSON.parse(cachedRaw);
          if(cachedObj&&Array.isArray(cachedObj.products)&&(Date.now()-Number(cachedObj.time||0))<CACHE_TTL){
            variantIndex=cachedObj.products;
            return Promise.resolve(variantIndex);
          }
        }
      }catch(e){}
      function firstWorkingIndex(sources,pos){
        if(pos>=sources.length)return Promise.resolve([]);
        return fetchIndexPage(1,[],sources[pos]).then(function(items){
          if(items&&items.length)return items;
          return firstWorkingIndex(sources,pos+1);
        }).catch(function(){return firstWorkingIndex(sources,pos+1);});
      }
      variantIndexPromise=firstWorkingIndex(indexSources(),0).then(function(items){
        if(items&&items.length)return items;
        /* Built-in Shopify catalogue fallback keeps SKU/title search alive even
           if every custom Liquid index route is unavailable in a preview theme. */
        return getProductsJsonIndex();
      }).then(function(items){
        var seen=Object.create(null);
        variantIndex=(items||[]).filter(function(p){var k=String(p&&p.id||p&&p.handle||'');if(!k||seen[k])return false;seen[k]=1;return true;});
        try{sessionStorage.setItem(variantIndexCacheKey,JSON.stringify({time:Date.now(),products:variantIndex}));}catch(e){}
        return variantIndex;
      }).finally(function(){variantIndexPromise=null;});
      return variantIndexPromise;
    }
    function indexedProductResult(product,variant,label,exact){
      var url=product&&product.url?product.url:(product&&product.handle?'/products/'+product.handle:'#');
      if(variant&&variant.id){
        try{var u=new URL(url,window.location.origin);u.searchParams.set('variant',variant.id);url=u.pathname+u.search+u.hash;}catch(e){}
      }
      return {
        id:product.id||product.handle,handle:product.handle||'',title:product.title||'',vendor:product.vendor||'',
        url:url,image:product.image||'',featured_image:product.image||'',price_min:product.price_min,compare_at_price_min:product.compare_at_price_min,
        match_label:label||'',is_exact_variant_match:!!exact,variants:product.variants||[]
      };
    }
    function searchVariantIndex(query){
      var text=normalize(query);
      var terms=text.split(/\s+/).filter(Boolean);
      var compact=normalizeCode(query);
      return getVariantIndex().then(function(items){
        var matches=[];
        (items||[]).forEach(function(product){
          var variantTitles=(product.variants||[]).map(function(v){return v&&v.title||'';}).join(' ');
          var productText=normalize([product.title,product.vendor,product.product_type,product.handle,variantTitles].join(' '));
          var productCompact=normalizeCode([product.title,product.vendor,product.product_type,product.handle,variantTitles].join(' '));
          var best=null;
          (product.variants||[]).forEach(function(v){
            var values=[['SKU',v.sku],['Ref.',v.supplier_ref],['EAN',v.barcode]];
            values.forEach(function(pair){
              var code=normalizeCode(pair[1]);
              if(!code||!compact)return;
              var exact=code===compact;
              var contains=!exact&&compact.length>=3&&code.indexOf(compact)!==-1;
              if(!exact&&!contains)return;
              var score=(exact?100:70)+(pair[0]==='Ref.'?3:(pair[0]==='SKU'?2:0));
              if(!best||score>best.score)best={score:score,variant:v,label:pair[0]+' '+String(pair[1]||''),exact:exact};
            });
          });
          if(!best){
            var textMatch=terms.length&&terms.every(function(t){return productText.indexOf(t)!==-1;});
            var compactMatch=compact.length>=3&&productCompact.indexOf(compact)!==-1;
            if(textMatch||compactMatch)best={score:20,variant:null,label:'',exact:false};
          }
          if(best)matches.push({score:best.score,product:indexedProductResult(product,best.variant,best.label,best.exact)});
        });
        matches.sort(function(a,b){return b.score-a.score;});
        return matches.slice(0,12).map(function(x){return x.product;});
      });
    }

    function normalize(value){
      return String(value || '')
        .trim()
        .toLocaleLowerCase(locale)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g,'');
    }

    /*
      Brand-aware search.
      We build the index from the actual header brand menu so the search stays
      aligned with the storefront navigation. Prefixes such as "meg" resolve
      to MEGAMO before calling Shopify predictive search.
    */
    var brandIndex = [];
    var brandSeen = Object.create(null);
    document.querySelectorAll('.mg2-curated-brands__grid a, .mg2-mobile-curated__brand-grid a').forEach(function(link){
      var name = String(link.textContent || '').replace(/^\s*\d+\s*/, '').trim();
      var normalizedName = normalize(name);
      if(!name || !normalizedName || brandSeen[normalizedName]) return;
      brandSeen[normalizedName] = true;
      brandIndex.push({name:name, normalized:normalizedName, href:link.getAttribute('href') || ''});
    });

    function detectBrand(query){
      var nq = normalize(query);
      if(!nq) return null;
      var terms = nq.split(/\s+/).filter(Boolean);
      var first = terms[0] || '';
      if(first.length < 2) return null;

      var matches = brandIndex.filter(function(brand){
        if(brand.normalized.indexOf(first) === 0) return true;
        return brand.normalized.split(/[^a-z0-9]+/).some(function(word){ return word.indexOf(first) === 0; });
      });
      if(!matches.length) return null;

      matches.sort(function(a,b){
        var aExact = a.normalized === first ? 0 : 1;
        var bExact = b.normalized === first ? 0 : 1;
        return aExact - bExact || a.normalized.length - b.normalized.length;
      });

      var match = matches[0];
      var rest = terms.slice(1).join(' ');
      return {
        name: match.name,
        normalized: match.normalized,
        href: match.href,
        requestQuery: rest ? (match.name + ' ' + rest) : match.name,
        isBrandOnly: terms.length === 1
      };
    }

    function strictSearchProducts(products, query){
      var nq = normalize(query);
      var terms = nq.split(/\s+/).filter(Boolean);
      if(!terms.length) return [];

      function fields(product){
        var title = normalize(product && product.title);
        var vendor = normalize(product && product.vendor);
        var skus = normalize(((product&&product.variants)||[]).map(function(v){return v&&v.sku||'';}).join(' '));
        return { title:title, vendor:vendor, skus:skus, haystack:(title + ' ' + vendor + ' ' + skus).trim() };
      }

      function termMatches(field, term){
        if(!field || !term) return false;
        if(field.indexOf(term) !== -1) return true;
        return field.split(/[^a-z0-9]+/).some(function(word){ return word.indexOf(term) === 0; });
      }

      function score(product){
        var f = fields(product);
        if(!terms.every(function(term){ return termMatches(f.haystack,term); })) return 999;
        if(f.vendor === nq) return 0;
        if(f.vendor.indexOf(nq) === 0) return 1;
        if(f.title === nq) return 2;
        if(f.title.indexOf(nq) === 0) return 3;
        if(f.vendor.indexOf(nq) !== -1) return 4;
        if(f.title.indexOf(nq) !== -1) return 5;
        return 6;
      }

      return (products || [])
        .map(function(product,index){ return {product:product,index:index,score:score(product)}; })
        .filter(function(entry){ return entry.score < 999; })
        .sort(function(a,b){ return a.score - b.score || a.index - b.index; })
        .map(function(entry){ return entry.product; });
    }
    function rows(){ return Array.prototype.slice.call(results.querySelectorAll('.mg2-search-result')); }

    function trimCache(){
      while(cache.size > MAX_CACHE){
        var first = cache.keys().next().value;
        cache.delete(first);
      }
    }

    function getCached(query){
      var entry = cache.get(query);
      if(!entry) return null;
      if((Date.now() - entry.time) >= CACHE_TTL){ cache.delete(query); return null; }
      return entry.products || [];
    }

    function putCached(query,products){
      cache.delete(query);
      cache.set(query,{time:Date.now(),products:products});
      trimCache();
      saveSessionCache(cache);
    }

    function setAllUrl(query,brand){
      if(brand && brand.isBrandOnly && brand.href){
        all.href = brand.href;
        return;
      }
      var u = new URL(form.action,window.location.origin);
      u.searchParams.set('q',brand ? brand.requestQuery : query);
      u.searchParams.set('type','product');
      all.href = u.pathname + u.search;
    }

    function resetActive(){
      activeIndex = -1;
      lastHoverRow = null;
      rows().forEach(function(row){ row.classList.remove('is-active'); row.setAttribute('aria-selected','false'); });
    }

    function setActive(index){
      var items = rows();
      if(!items.length){ activeIndex = -1; return; }
      if(index < 0) index = items.length - 1;
      if(index >= items.length) index = 0;
      activeIndex = index;
      items.forEach(function(row,i){
        var active = i === activeIndex;
        row.classList.toggle('is-active',active);
        row.setAttribute('aria-selected',active ? 'true' : 'false');
      });
      items[activeIndex].scrollIntoView({block:'nearest'});
    }

    function navigateToResult(item){
      if(!item || !item.href) return false;
      document.documentElement.classList.remove('mg2-lock');
      if(document.body) document.body.classList.remove('mg2-lock');
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden','true');
      window.location.href = item.href;
      return true;
    }

    function selectedOrFirstResult(){
      var items = rows();
      if(!items.length) return null;
      if(activeIndex >= 0 && activeIndex < items.length) return items[activeIndex];
      return items[0];
    }

    function clearResults(showEmpty){
      if(controller){ try{controller.abort();}catch(e){} controller = null; }
      window.clearTimeout(timer);
      results.replaceChildren();
      status.textContent = '';
      content.classList.remove('is-searching');
      all.hidden = true;
      empty.hidden = !showEmpty;
      resetActive();
      lastProducts = [];
      lastQuery = '';
    }

    function metaLine(product,year){
      var bits = [];
      if(product && product.vendor) bits.push(product.vendor);
      if(year) bits.push(year);
      if(product && product.match_label) bits.push(product.match_label);
      return bits.join(' · ');
    }

    function renderProducts(products,query,options){
      options = options || {};
      empty.hidden = true;
      resetActive();

      if(!products || !products.length){
        results.replaceChildren();
        status.textContent = options.local ? 'Buscando…' : 'No encontramos eBikes para “' + query + '”.';
        setAllUrl(query,options.brand);
        all.hidden = !!options.local;
        return;
      }

      var html = products.slice(0,6).map(function(product,index){
        var image = thumbUrl(productImage(product),144);
        var price = product.price_min != null ? product.price_min : product.price;
        var compare = product.compare_at_price_min != null ? product.compare_at_price_min : product.compare_at_price;
        var p = numberValue(price);
        var c = numberValue(compare);
        var offer = Number.isFinite(c) && Number.isFinite(p) && c > p;
        var year = productYear(product);
        var media = image
          ? '<span class="mg2-search-result__media"><img src="' + esc(image) + '" alt="' + esc(productImageAlt(product)) + '" width="72" height="72" loading="lazy" decoding="async" fetchpriority="low"></span>'
          : '<span class="mg2-search-result__media mg2-search-result__media--empty">SIN IMAGEN</span>';
        return '<a class="mg2-search-result" role="option" aria-selected="false" data-search-index="' + index + '" href="' + esc(productUrl(product)) + '">' +
          media +
          '<span class="mg2-search-result__body">' +
            '<strong class="mg2-search-result__title">' + esc(product.title || '') + '</strong>' +
            '<span class="mg2-search-result__meta">' + esc(metaLine(product,year) || 'LaBosch') + '</span>' +
          '</span>' +
          '<span class="mg2-search-result__price-wrap">' +
            '<span class="mg2-search-result__price' + (offer ? ' is-offer' : '') + '">' + esc(money(price)) + '</span>' +
            (offer ? '<s class="mg2-search-result__compare">' + esc(money(compare)) + '</s>' : '') +
          '</span>' +
        '</a>';
      }).join('');

      results.innerHTML = html;
      /* The first live result is the default Enter target. Exact SKU/REF/EAN
         matches are ranked first and already carry ?variant=<id>. */
      setActive(0);
      status.textContent = options.brand ? ('Marca detectada: ' + options.brand.name + ' · ' + products.length + (products.length === 1 ? ' resultado' : ' resultados')) : (options.local ? 'Resultados instantáneos' : products.length + (products.length === 1 ? ' resultado' : ' resultados'));
      setAllUrl(query,options.brand);
      all.hidden = !!options.local;
      if(!options.local){
        lastProducts = products;
        lastQuery = normalize(query);
      }
    }

    function productHaystack(product){
      return normalize([
        product.title || '', product.vendor || '', productYear(product),
        Array.isArray(product.tags) ? product.tags.join(' ') : (product.tags || '')
      ].join(' '));
    }

    function localFilter(query){
      if(!lastProducts.length || !lastQuery) return [];
      var nq = normalize(query);
      if(nq.indexOf(lastQuery) !== 0) return [];
      var terms = nq.split(/\s+/).filter(Boolean);
      return lastProducts.filter(function(product){
        var haystack = productHaystack(product);
        return terms.every(function(term){ return haystack.indexOf(term) !== -1; });
      });
    }

    function bestPrefixCache(query){
      var nq = normalize(query);
      var best = null;
      cache.forEach(function(entry,key){
        if(!entry || !entry.products || !entry.products.length) return;
        if((Date.now() - entry.time) >= CACHE_TTL) return;
        if(nq.indexOf(key) === 0 && (!best || key.length > best.key.length)) best = {key:key,products:entry.products};
      });
      if(!best) return [];
      var terms = nq.split(/\s+/).filter(Boolean);
      return best.products.filter(function(product){
        var haystack = productHaystack(product);
        return terms.every(function(term){ return haystack.indexOf(term) !== -1; });
      });
    }

    function mergeSearchProducts(indexProducts,predictiveProducts,brand){
      var merged=[];
      var seen=Object.create(null);
      function add(product){
        if(!product)return;
        if(brand){
          var vendor=normalize(product.vendor||'');
          if(!(vendor===brand.normalized||vendor.indexOf(brand.normalized)===0))return;
        }
        var key=String(product.handle||product.id||product.url||'');
        if(!key||seen[key])return;
        seen[key]=1;
        merged.push(product);
      }
      /* Index results are intentionally first: exact SKU/reference/EAN matches
         must outrank Shopify's fuzzy title suggestions. */
      (indexProducts||[]).forEach(add);
      (predictiveProducts||[]).forEach(add);
      return merged.slice(0,12);
    }

    function search(query){
      var normalized=normalize(query);
      if(!normalized)return;

      var brand=detectBrand(query);
      var requestQuery=brand?brand.requestQuery:query;
      var cacheKey=brand?('@brand:'+brand.normalized+'|'+normalize(requestQuery)):normalized;
      var cached=getCached(cacheKey);
      if(cached){
        lastProducts=cached;
        lastQuery=normalized;
        renderProducts(cached,query,{brand:brand,index:true});
        if(cached.some(function(p){return p&&p.match_label;})) all.hidden=true;
        return;
      }

      var current=++requestId;
      if(controller){try{controller.abort();}catch(e){}}
      controller=new AbortController();
      content.classList.add('is-searching');

      var rootRoute=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      var url=rootRoute+'search/suggest.json?resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show&resources[options][fields]=title%2Cvendor%2Cvariants.sku&q='+encodeURIComponent(requestQuery);

      var predictive=fetch(url,{headers:{'Accept':'application/json'},signal:controller.signal,credentials:'same-origin',cache:'force-cache',priority:'high'})
        .then(function(response){if(!response.ok)throw new Error('HTTP '+response.status);return response.json();})
        .then(function(data){
          var products=data&&data.resources&&data.resources.results&&data.resources.results.products;
          products=products||[];
          var strict=strictSearchProducts(products,requestQuery);
          if(strict.length)return strict;
          var codeProbe=normalizeCode(requestQuery);
          if(codeProbe.length>=4&&/[0-9]/.test(codeProbe))return products;
          return strict;
        })
        .catch(function(err){
          if(err&&err.name==='AbortError')return [];
          return [];
        });

      /* Always consult the complete variant index for >=2 characters. This is
         deliberate: supplier references can be alphabetic and Shopify does not
         index custom metafields reliably. /collections/all also prevents a bike
         from disappearing just because it is absent from one merchandising collection. */
      var indexed=normalized.length>=2?searchVariantIndex(query).catch(function(){return [];}):Promise.resolve([]);

      Promise.all([indexed,predictive]).then(function(parts){
        if(current!==requestId)return;
        content.classList.remove('is-searching');
        var indexProducts=parts[0]||[];
        var predictiveProducts=parts[1]||[];
        var products=mergeSearchProducts(indexProducts,predictiveProducts,brand);
        putCached(cacheKey,products);
        renderProducts(products,query,{brand:brand,index:indexProducts.length>0});
        /* Shopify's regular /search page cannot resolve custom supplier refs;
           keep the authoritative in-overlay result as the primary action. */
        if(indexProducts.some(function(p){return p&&p.match_label;})) all.hidden=true;
      }).catch(function(){
        if(current!==requestId)return;
        content.classList.remove('is-searching');
        status.textContent='No se ha podido cargar la búsqueda en directo.';
        setAllUrl(query,brand);
        all.hidden=false;
      });
    }

    input.addEventListener('input',function(){
      var query = input.value.trim();
      window.clearTimeout(timer);

      if(query.length < 1){ clearResults(true); return; }

      var normalized = normalize(query);
      var brand = detectBrand(query);
      var requestQuery = brand ? brand.requestQuery : query;
      var cacheKey = brand ? ('@brand:' + brand.normalized + '|' + normalize(requestQuery)) : normalized;
      var exact = getCached(cacheKey);
      if(exact){
        lastProducts = exact;
        lastQuery = normalized;
        renderProducts(exact,query,{brand:brand,index:true});
        if(exact.some(function(p){return p&&p.match_label;})) all.hidden=true;
        return;
      }

      var instant = localFilter(query);
      if(!instant.length) instant = bestPrefixCache(query);

      /* For a recognized brand prefix we prefer a fast authoritative refresh
         instead of showing stale products from another query. */
      if(brand){
        empty.hidden = true;
        if(!results.children.length) status.textContent = 'Buscando ' + brand.name + '…';
        timer = window.setTimeout(function(){ search(query); },70);
      }else if(instant.length){
        renderProducts(instant,query,{local:true});
        timer = window.setTimeout(function(){ search(query); },360);
      }else{
        empty.hidden = true;
        if(!results.children.length) status.textContent = query.length < 2 ? 'Sigue escribiendo…' : 'Buscando…';
        timer = window.setTimeout(function(){ search(query); }, query.length < 2 ? 160 : 95);
      }
    },{passive:true});

    input.addEventListener('focus',function(){
      if(input.value) try{ input.select(); }catch(e){}
    });

    input.addEventListener('search',function(){ if(!input.value.trim()) clearResults(true); });

    input.addEventListener('keydown',function(event){
      if(event.key === 'ArrowDown'){
        event.preventDefault(); setActive(activeIndex + 1);
      }else if(event.key === 'ArrowUp'){
        event.preventDefault(); setActive(activeIndex - 1);
      }else if(event.key === 'Enter'){
        var item = selectedOrFirstResult();
        if(item){
          event.preventDefault();
          event.stopPropagation();
          navigateToResult(item);
        }
      }
    });

    /* Never fall through to Shopify's generic /search page when the live
       spotlight already has a concrete product/variant result. This also
       covers submit events fired by keyboards/assistive tech without keydown. */
    form.addEventListener('submit',function(event){
      var item = selectedOrFirstResult();
      if(!item) return;
      event.preventDefault();
      event.stopPropagation();
      navigateToResult(item);
    });

    /* pointermove used to run on every mouse pixel. pointerover only updates once per row. */
    results.addEventListener('pointerover',function(event){
      var row = event.target.closest('.mg2-search-result');
      if(!row || row === lastHoverRow) return;
      lastHoverRow = row;
      var items = rows();
      var index = items.indexOf(row);
      if(index < 0) return;
      activeIndex = index;
      items.forEach(function(item,i){
        var active = i === index;
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-selected',active ? 'true' : 'false');
      });
    },{passive:true});

    overlay.addEventListener('transitionend',function(event){
      if(event.target !== overlay) return;
      if(!overlay.classList.contains('is-open')){
        if(controller){ try{controller.abort();}catch(e){} controller = null; }
        window.clearTimeout(timer);
        results.replaceChildren();
        status.textContent = '';
        all.hidden = true;
        empty.hidden = false;
        input.value = '';
        content.classList.remove('is-searching');
        lastProducts = [];
        lastQuery = '';
        resetActive();
      }
    });
  }

  var bootQueued = false;
  function boot(){ bootLiveSearch(); }
  function scheduleBoot(){
    if(bootQueued) return;
    bootQueued = true;
    window.requestAnimationFrame(function(){
      bootQueued = false;
      boot();
    });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
  window.addEventListener('pageshow',scheduleBoot);
  window.addEventListener('popstate',scheduleBoot);
  document.addEventListener('shopify:section:load',scheduleBoot);
  document.addEventListener('shopify:section:reorder',scheduleBoot);
  document.addEventListener('shopify:navigation:complete',scheduleBoot);
  document.addEventListener('theme:page:load',scheduleBoot);
  document.addEventListener('page:load',scheduleBoot);
  document.addEventListener('turbo:load',scheduleBoot);
  document.addEventListener('click',function(event){
    if(event.target && event.target.closest && event.target.closest('[data-mg2-search-open]')) scheduleBoot();
  },true);

})();
